import { Link, useNavigate } from "react-router-dom";
import { Trash2, ShoppingCart, ArrowRight, PackageOpen } from "lucide-react";
import { API } from "@/lib/api";
import { zl, useCart } from "@/lib/shop";
import ShopLayout from "./ShopLayout";
import { Button } from "@/components/ui/button";

export default function ShopCart() {
  const { items, subtotal, update, remove } = useCart();
  const navigate = useNavigate();

  return (
    <ShopLayout>
      <div className="mx-auto max-w-4xl px-4 py-10">
        <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight mb-8">Koszyk</h1>
        {items.length === 0 ? (
          <div className="grid place-items-center py-20 text-neutral-500" data-testid="cart-empty">
            <ShoppingCart className="h-12 w-12 mb-4" />
            <p className="mb-4">Twój koszyk jest pusty.</p>
            <Link to="/sklep"><Button className="bg-amber-400 text-[#0D1117] hover:bg-amber-300 font-bold">Przejdź do sklepu</Button></Link>
          </div>
        ) : (
          <div className="space-y-4">
            {items.map((it, i) => (
              <div key={i} data-testid={`cart-item-${i}`} className="flex items-center gap-4 rounded-xl border border-white/10 bg-white/5 p-3">
                <div className="h-20 w-20 shrink-0 rounded-lg bg-white overflow-hidden">
                  {it.photo ? <img src={`${API}/files/${it.photo}`} alt="" className="h-full w-full object-contain bg-white" /> : <div className="grid h-full place-items-center text-neutral-300"><PackageOpen className="h-7 w-7" /></div>}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-semibold truncate">{it.name}</p>
                  <p className="text-xs text-neutral-400">{[it.color, it.size].filter(Boolean).join(" · ")}</p>
                  <p className="mt-1 text-sm font-bold">{zl(it.price_grosz)}</p>
                </div>
                <div className="flex items-center rounded-lg border border-white/15">
                  <button onClick={() => update(i, it.quantity - 1)} className="h-9 w-9 hover:text-amber-400">−</button>
                  <span className="w-8 text-center text-sm">{it.quantity}</span>
                  <button onClick={() => update(i, it.quantity + 1)} className="h-9 w-9 hover:text-amber-400">+</button>
                </div>
                <div className="w-24 text-right font-bold">{zl(it.price_grosz * it.quantity)}</div>
                <button data-testid={`cart-remove-${i}`} onClick={() => remove(i)} className="text-rose-400 hover:text-rose-300"><Trash2 className="h-5 w-5" /></button>
              </div>
            ))}
            <div className="flex items-center justify-between border-t border-white/10 pt-5">
              <span className="text-neutral-400">Wartość produktów</span>
              <span className="text-2xl font-extrabold" data-testid="cart-subtotal">{zl(subtotal)}</span>
            </div>
            <p className="text-xs text-neutral-500 text-right">Koszt dostawy zostanie dodany w kolejnym kroku.</p>
            <div className="flex justify-end gap-3 pt-2">
              <Link to="/sklep"><Button variant="outline" className="border-white/20 text-neutral-200 hover:bg-white/5">Kontynuuj zakupy</Button></Link>
              <Button data-testid="cart-checkout-btn" onClick={() => navigate("/sklep/zamowienie")} className="bg-amber-400 text-[#0D1117] hover:bg-amber-300 font-bold uppercase tracking-wider gap-2">Przejdź do kasy<ArrowRight className="h-4 w-4" /></Button>
            </div>
          </div>
        )}
      </div>
    </ShopLayout>
  );
}
